import {
  ROUTE_TRAQING_EXPERT_PROVIDER,
  ROUTE_TRAQING_USER_REPORTS,
  ROUTE_TRAQING_USER_STATUS,
} from "Consts/publicRoutes";

export const SIDENAV_TRAQING_SECTION = {
  text: "Traqing",
  userRoute: ROUTE_TRAQING_USER_STATUS,
  restrictedRoute: ROUTE_TRAQING_EXPERT_PROVIDER,
};

export const SIDENAV_TRAQING_STATUS_ROUTE = {
  route: { name: ROUTE_TRAQING_USER_STATUS },
  text: "Status",
};

export const SIDENAV_TRAQING_REPORT_ROUTE = {
  route: { name: ROUTE_TRAQING_USER_REPORTS },
  text: "Reports",
};

export const SIDENAV_TRAQING_COACH_ROUTE = {
  route: { name: ROUTE_TRAQING_EXPERT_PROVIDER },
  text: "Reports",
};
